import { HeadingTag } from '@sapientpro/sapientpro-data-models';
import { createElement, ReactNode } from 'react';

interface IDynamicHeadingProps {
  headingTag: HeadingTag;
  children: ReactNode;
  className?: string;
  nestingLevel?: number;
}

const DynamicHeading = ({
  headingTag = 'h2', children, nestingLevel = 0, ...args
}: IDynamicHeadingProps) => {
  const headingNumber = Number(headingTag.split('h').join(''));
  const elementNumber = Math.min(6, headingNumber + nestingLevel);
  const tagName = `h${elementNumber}`;

  return createElement(tagName, args, children);
};
export default DynamicHeading;
